import { render, staticRenderFns, recyclableRender, components } from "./u-text.vue?vue&type=template&id=50004b49&scoped=true&"
var renderjs
import script from "./u-text.vue?vue&type=script&lang=js&"
export * from "./u-text.vue?vue&type=script&lang=js&"
import style0 from "./u-text.vue?vue&type=style&index=0&id=50004b49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Program Files/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50004b49",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uview-ui/components/u-text/u-text.vue"
export default component.exports